/**
 * æ¯ä¸éé¡¹çåå®¹
 */
export class CascadeVerticalItem {
  /**
   * parentId ç¶id
   * id å½åé¡¹id
   * contentText åå®¹
   * children å­éé¡¹
   * {boolean} chosen æ¯å¦å·²é
   */
  constructor(public parentId: number, public id: number, public contentText: string,
    public children: CascadeVerticalItem[] = [], public chosen = false) {
  }

  hasChild(): boolean {
    return this.children && this.children.length > 0;
  }
}
